import * as Sentry from "@sentry/react";
import { getDisplayInfo } from "../../../src/shared/LedgerEntryDisplayMap";

export const getLedgerDisplayInfo = (ledgerEntry) => {
  const sendError = (err: Error, extra?: Record<string, unknown>) => {
    Sentry.captureException(err, {
      tags: {
        ledgerEntryType: ledgerEntry.type,
        ledgerEntrySource: ledgerEntry.source,
        userId: ledgerEntry.userId,
        ledgerEntryId: ledgerEntry.id,
      },
      extra,
    });
  };
  const displayInfo = getDisplayInfo(ledgerEntry, sendError);
  if (!displayInfo) {
    return false;
  }
  return displayInfo;
};
